/**
 * DevisCreate — page « Nouveau devis » (iter262).
 *
 * Même ergonomie que « Nouvel OR » (/atelier/or/nouveau) et « Nouvelle facture »
 * (/facturation/nouveau) : une page plein écran, plus de fenêtre au milieu.
 */
import { useNavigate } from "react-router-dom";
import { ArrowLeft, FileCheck } from "lucide-react";
import DevisForm from "@/components/devis/DevisForm";

export default function DevisCreate() {
  const navigate = useNavigate();
  const retour = () => navigate("/facturation", { state: { tab: "devis" } });

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-5xl mx-auto" data-testid="devis-create-page">
      <button
        onClick={retour}
        className="text-sm text-gray-500 hover:text-gray-900 inline-flex items-center gap-1 mb-3"
        data-testid="devis-create-back"
      >
        <ArrowLeft className="w-4 h-4" /> Retour
      </button>

      <h1 className="text-2xl sm:text-3xl font-heading font-bold text-gray-900 flex items-center gap-2 mb-2">
        <FileCheck className="w-7 h-7 text-[#52a675]" /> Nouveau devis
      </h1>
      <p className="text-sm text-gray-500 mb-6">
        Devis autonome avec catalogue articles, rabais et calcul automatique.
      </p>

      <DevisForm asPage onClose={retour} onCreated={retour} />
    </div>
  );
}
